import gql from 'graphql-tag'

export const fetchCartQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    outlet_details {
      payer_name
      outlet_name
      street
      city
      country
      province
      postalcode
      sap_id
    }
    payer_details {
      payername
      street
      city
      country
      zipcode
      sap_id
      identification_no
      taxvat
    }
    progress_bar_data {
      iMinimumOrderPallet,
      iMaximumOrderPallet,
      iMinimumOrderWeight,
      iMaximumOrderWeight,
      iMinimumUnit,
      iMaximumUnit,
      iKegFlag,
      iCustomerType,
      iTotalCartWeight,
      iTotalCartPalletQty,
      iTotalQty,
      msg,
      canProceed
    }
    id
    email
    total_quantity
    multi_deposit
    ship_to_id
    grand_total_basic_price
    grand_total_basic_price_tax
    grand_total_multi_deposit
    bundle_your_price_sum_grand_total
    bundle_your_price_sum_grand_total_tax
    cart_prices {
      grand_total_deposit
      grand_total_deposit_with_vat
      grand_total_price
      grand_total_price_with_vat
      grand_total_price_with_vat_returnable
      grand_total_price_with_vat_returnable_vat
      grand_total_redemption_fee
      returnable_items{
        parent_sku
        sku
        total_units
        total_price
        unit_price
        name
      }
    }
    quantity_totals
    items {
      id
      uid
      quantity_total
      prices {
        your_price_details {
          your_price
          your_price_tax
          redemption_fee
          multi_deposit_with_vat
          total_your_price
          total_your_price_tax
          multi_deposit
        }
        package_percentage_discount
      }
      product {
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
          __typename
        }
        id
        name
        sku
        url_key
        material_type
        number_of_items_in_box
        number_of_items_on_pallet
        number_of_products_on_layer
        number_of_layers_per_pallet
         product_reco_tags {
          value
          label
          color
        }
        redemption_fee
        multi_deposit_z099
        package_type
        pack_format
        isavailable_truck_package_ordering
        bundle_product_details {
          sku
          catalog_product_name
          bundle_quantity
          price_per_unit_w_vat
          price_per_unit_wo_vat
          price_per_unit_wo_vat_discounted
          price_per_unit_w_vat_discounted
        }
        image {
          url
        }
        ... on BundleProduct {
          bundle_price_details
        }
        __typename
      }
      ... on BundleCartItem {
          bundle_options {
            uid
            label
            type
            values {
              id
              label
              price
              quantity
            }
          }
        }
      quantity
      quantity_total
      number_of_packages
      number_of_layer
      number_of_layer_total
      number_of_pallet
      number_of_pallet_from_fe
      number_of_layer_from_fe
      quantity_from_fe
      pack_format
    }
    prices {
      discounts {
        amount {
          value
        }
        label
      }
      grand_total {
        value
      }
    }
    empties{
      packaging_name
      packaging_volume
      packaging_issued
      number_of_units
      unit_of_measure
      total
    }
    cart_blga {
      packaging_name
      packaging_volume
      number_of_units
      unit_of_measure
      total
    }
  }
}
`)
